// extracted by mini-css-extract-plugin
module.exports = {"popup":"Map-module--popup--2doCZ","innerPoup":"Map-module--innerPoup--3usuF","mapLabels":"Map-module--mapLabels--1T8w_","landmark":"Map-module--landmark--1P481"};